module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "nav-desktop",
    class: {
      "nav-desktop--scrolling": _vm.$store.state.nav, "nav-desktop--notransparent": _vm.$route.path === "/"
    }
  }, [_c('div', {
    staticClass: "nav-desktop__container"
  }, [_c('div', {
    staticClass: "nav-desktop__item"
  }, [_c('div', {
    staticClass: "nav-desktop__dropdown",
    class: {
      "nav-desktop__dropdown--active": _vm.$store.state.menu
    },
    on: {
      "click": _vm.dropdown
    }
  }, [_c('span', [_vm._v("GET IN TOUCH")]), _c('Icon', {
    staticClass: "nav-desktop__dropdown-icon",
    class: {
      "nav-desktop__dropdown-icon--open": _vm.open
    },
    attrs: {
      "name": "triangle"
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "nav-desktop__dropdown-container"
  }, [_c('a', {
    staticClass: "nav-desktop__dropdown-phone",
    attrs: {
      "href": _vm.props.acf.social_links[0].href
    }
  }, [_c('Icon', {
    staticClass: "nav-desktop__phone",
    attrs: {
      "name": "phone"
    }
  }), _c('p', [_vm._v("585. 742. 1050  ")])], 1), _c('a', {
    staticClass: "nav-desktop__dropdown-phone-emergency",
    attrs: {
      "href": _vm.props.acf.phone.href
    }
  }, [_c('Icon', {
    staticClass: "nav-desktop__phone-emergency",
    attrs: {
      "name": "bandaid"
    }
  }), _c('p', [_vm._v(_vm._s(_vm.props.acf.phone.label))])], 1), _c('a', {
    staticClass: "nav-desktop__dropdown-map",
    attrs: {
      "href": _vm.props.acf.address.href,
      "target": "_blank"
    }
  }, [_c('Icon', {
    staticClass: "nav-desktop__map",
    attrs: {
      "name": "location"
    }
  }), _c('p', [_vm._v("MAP  ")])], 1), _c('a', {
    staticClass: "nav-desktop__dropdown-email",
    attrs: {
      "href": _vm.props.acf.social_links[1].href
    }
  }, [_c('Icon', {
    staticClass: "nav-desktop__email",
    attrs: {
      "name": "envelope"
    }
  }), _c('p', [_vm._v("EMAIL US")])], 1)])])], 1)]), _c('div', {
    staticClass: "nav-desktop__item"
  }, [_c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: "#head",
        container: "body",
        duration: 750,
        easing: "ease-in-out",
        x: false,
        y: true
      }),
      expression: "{el: \"#head\", container: \"body\", duration: 750, easing: \"ease-in-out\", x: false, y: true}"
    }],
    staticClass: "nav-desktop__logo-container",
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('Icon', {
    staticClass: "nav-desktop__logo",
    class: {
      "nav-desktop__logo--active": _vm.$store.state.menu
    },
    attrs: {
      "name": "matt_logo-01"
    }
  })], 1)]), _c('div', {
    staticClass: "nav-desktop__item"
  }, [_c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: "#head",
        container: "body",
        duration: 750,
        easing: "ease-in-out",
        x: false,
        y: true
      }),
      expression: "{el: \"#head\", container: \"body\", duration: 750, easing: \"ease-in-out\", x: false, y: true}"
    }],
    staticClass: "nav-desktop__menu-container",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "nav-desktop__menu"
  }, [_vm._v("MENU")]), _c('div', {
    staticClass: "nav-desktop__hamburger",
    class: {
      "nav-desktop__hamburger--active": _vm.$store.state.menu
    }
  }, [_c('span'), _c('span')])])])]), _c('Bottom')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58c7329c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/nav-desktop/nav-desktop.pug
// module id = 706
// module chunks = 1